import { useEffect, useState } from "react";
import ReactLoading from "react-loading";

import usePriority from "../../../Hooks/Support/usePriority";

import Item from "./Item";

import { Text } from "../../../Components/Text";
import { ContainerFlex } from "../../../Components/Layout";
import { Button, ButtonModal } from "../../../Components/Button";
import { Card, CardBody, CardHeader } from "../../../Components/Card";

const List = ({ setReload }) => {
  const { listPriority } = usePriority();

  const [loading, setLoading] = useState(true);
  const [category, setPriority] = useState([]);

  useEffect(() => {
    if (listPriority && listPriority.data) {
      setPriority(listPriority.data);
      setLoading(false);
    }
  }, [listPriority]);

  const handlePriority = () => {
    if (category && category.length > 0) {
      return category.map((data, index) => (
        <Item key={index} item={data}></Item>
      ));
    } else {
      <ContainerFlex full middle center column>
        <Text>Nenhum item foi localizado.</Text>
      </ContainerFlex>;
    }
  };

  return (
    <Card marginTop="3" padding="2">
      <CardHeader between middle>
        <Text className="h5" margin="0">
          Lista de Prioridades de Suporte
        </Text>
        <ContainerFlex row>
          <Button onClick={setReload} id="btn-reload-campaign">
            <Text tag="i" className="fa fa-redo-alt" />
          </Button>
          <ButtonModal modal="Support_Priority_Modal">
            <Text tag="i" className="fa fa-plus" />
          </ButtonModal>
        </ContainerFlex>
      </CardHeader>
      <CardBody padding="0">
        <ContainerFlex
          padding="2"
          className="accordion accordion-flush"
          id="campaign-collapse-list"
        >
          {/* <Item /> */}
          {loading ? (
            <ContainerFlex full middle center column>
              <ReactLoading type={"spin"} color={"#1c208c"} />
              <Text>Carregando...</Text>
            </ContainerFlex>
          ) : (
            handlePriority()
          )}
        </ContainerFlex>
      </CardBody>
    </Card>
  );
};

export default List;
